import React,{useState} from 'react';
import useStyles, { getMuiTheme } from "./styles";

import { useTheme, Grid, Typography } from '@material-ui/core/';
import { MuiThemeProvider } from "@material-ui/core/styles";
import NumberFormat from 'react-number-format';
import { pathOr } from "ramda";

import Xirr from './xirr';
import CustomAccordionTable from './customAccordionTable';
import CustomReports from './customReports';
import PolicyXirr from './PolicyXirr';

function CustomTableList({ data,setValue,setShowXirrVersion,showXirrVersion,allTabFilter }) {
  const classes = useStyles();
  const theme = useTheme();
  const [subType,setSubType]=useState(pathOr('', ['subType'], data));
  const isAccordionTable = pathOr(false, ['data', 'data', 'isAccordionTable'], data);
  const dashletType = pathOr(false, ['data', 'dashletType'], data);
// console.log("useState",subType,data)
 
const makeid=()=> {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  
  for (var i = 0; i < 5; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  
  return text;
  }

  let setComponent = <></>;
  if(subType === 'Custom Reports'){
    setComponent = <CustomReports key={makeid()} data={data} allTabFilter={allTabFilter}/>;
  }else if(isAccordionTable){
    setComponent = <CustomAccordionTable key={makeid()} data={data} setValue={setValue}/>;
  }else if(dashletType==='policy_summary'){
    setComponent = <PolicyXirr key={makeid()} data={data} setValue={setValue} setShowXirrVersion={setShowXirrVersion} allTabFilter={allTabFilter}/>;

  }else{
    setComponent = <Xirr key={makeid()} data={data} setValue={setValue} setShowXirrVersion={setShowXirrVersion} showXirrVersion={showXirrVersion} allTabFilter={allTabFilter}/>;
  }
  
  return (
    <MuiThemeProvider theme={getMuiTheme(theme)}>
      <Grid
        container
        direction="row"
        // justifyContent="space-between"
        alignItems="center"
      >
        {data.isSubHeader ? <Grid item xs={12}>
          <Typography className={classes.axaLabel} >
            {data.label}
          </Typography>
        </Grid> : null}

        <Grid item xs={12}>
        {setComponent}
       {/* {subType==='Custom Reports'?<CustomReports key={makeid()} data={data}/>: isAccordionTable ? <CustomAccordionTable key={makeid()} data={data} setValue={setValue}/> :<Xirr key={makeid()} data={data} setValue={setValue} setShowXirrVersion={setShowXirrVersion}/>} */}
        </Grid>
      </Grid>
     
    </MuiThemeProvider>
  );
}
export default React.memo(CustomTableList)